import {
  FORGET_PASSWORD,
  FORGET_PASSWORD_SUCCESS,
  FORGET_PASSWORD_ERROR,
  FORGET_PASSWORD_RESEND_CODE,
  FORGET_PASSWORD_RESEND_CODE_SUCCESS,
  FORGET_PASSWORD_RESEND_CODE_ERROR
} from "./actionTypes"

export const userForgetPassword = (user, history) => {
  return {
    type: FORGET_PASSWORD,
    payload: { user, history },
  }
}

export const userForgetPasswordSuccess = () => {
  return {
    type: FORGET_PASSWORD_SUCCESS,
    payload:  {},
  }
}

export const userForgetPasswordError = message => {
  return {
    type: FORGET_PASSWORD_ERROR,
    payload: message,
  }
}

//Forget password resend code
export const userForgetPasswordResendCode = (user, history) => {
  return {
    type: FORGET_PASSWORD_RESEND_CODE,
    payload: { user, history },
  }
}

export const userForgetPasswordResendCodeSuccess = message => {
  return {
    type: FORGET_PASSWORD_RESEND_CODE_SUCCESS,
    payload: message,
  }
}

export const userForgetPasswordResendCodeError = message => {
  return {
    type: FORGET_PASSWORD_RESEND_CODE_ERROR,
    payload: message,
  }
}